import { render, staticRenderFns } from "./question-image-preview.vue?vue&type=template&id=164c03da&scoped=true&"
import script from "./question-image-preview.vue?vue&type=script&lang=js&"
export * from "./question-image-preview.vue?vue&type=script&lang=js&"
import style0 from "./question-image-preview.vue?vue&type=style&index=0&id=164c03da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164c03da",
  null
  
)

export default component.exports